/**
 * The CustomTable filter-key grammar — the single shared vocabulary.
 *
 * The backend encodes a saved view's filters into flat query keys using these
 * affixes (`_handler`, `_start`, `_end`, `min_`, `max_`, `_operator`). Both the
 * URL/view encoder (filterParams.ts) and the chip display layer (filterChips.ts)
 * parse and build keys through these definitions, so the convention lives in one
 * place and the two modules stay independent of each other.
 */

export const HANDLER_SUFFIX = '_handler';
export const OPERATOR_SUFFIX = '_operator';
export const RANGE_START_SUFFIX = '_start';
export const RANGE_END_SUFFIX = '_end';
export const MIN_PREFIX = 'min_';
export const MAX_PREFIX = 'max_';

export const EMPTY_OPERATOR = 'null';
export const FILLED_OPERATOR = 'not_null';
export const UNSET_BOUND = 'null';

export const BOOKKEEPING_KEYS = ['sort_order', 'sort_by', 'page', 'page_limit'];

export const suffixFieldName = (key: string) => key.substring(0, key.lastIndexOf('_'));

export const rangeFieldName = (key: string) => key.substring(MIN_PREFIX.length);

// indexOf (substring match, not startsWith) and the 4-char slice in
// rangeFieldName both preserve the original's exact behaviour — keep as-is.
export const isMinMaxKey = (key: string) =>
  key.indexOf(MIN_PREFIX) + key.indexOf(MAX_PREFIX) !== -2;
